export const sanitizeNumericValue = (value: unknown): string =>
    String(value ?? '').replace(/[^\d.]/g, '');
